window.WHATSAPP_TOP_LINKS = [
  { text: "Crie a sua conta", url: "/account/register" },
  { text: "Alterar endereço de entrega", url: "/account/addresses" },
  { text: "Solicitar devolução", url: "/pages/trocas-e-devolucoes" },
  { text: "Tabela de medidas", url: "/pages/tabela-de-medidas" },
  { text: "Política de trocas", url: "/policies/refund-policy" },
  { text: "Prazo de envio", url: "/policies/shipping-policy" },
  { text: "Falar com atendimento", url: "/pages/contact" },
  { text: "Falar com uma personal shopper", url: "/pages/personal-shopper" }
];